<div class="chart-container center-start">
    <div *ngIf="data.length > 0; else noData" style="width: 100%">
        <div *ngFor="let item of data; let i = index">
            <div class="bar-item start-center">
                <p class="item-label">
                    {{ item.title ? item.title : "Not Specified" }}
                </p>
                <div class="start-center bar-container">
                    <div
                        class="bar-wrapper"
                        [ngStyle]="{
                            width: '100%'
                        }"
                    >
                        <div class="total-bar"></div>
                        <div
                            class="active-bar"
                            [ngStyle]="{
                                width:
                                    item.total === 0
                                        ? 0
                                        : (item.total / maxCount) * 100 +
                                            '%',
                                background: colorsSchema[i % 5]
                            }"
                        ></div>
                    </div>
                    <p class="counts-text" *ngIf="!item.active">
                        {{ item.total }}
                    </p>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noData>
        <p>No Data!</p>
    </ng-template>
</div>
